function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg viewBox="0 0 612 588" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M306 587.76L0 252.04h612L306 587.76m157.14-335.72H148.87V.24h314.27v251.8" /></svg>;
});